<div class="tw-relative tw-flex tw-flex-col tw-items-center tw-gap-8 tw-bg-white tw-px-6 tw-py-8 tw-rounded-t-3xl">
  <div class="tw-absolute tw-right-6 tw-top-6 tw-flex tw-items-center tw-justify-center tw-text-gray-800"
       (click)="closedPopup()"
       id="closedPopupBtn">
    <cs-icon class="tw-h-3.5 tw-w-3.5" [iconName]="'bottomsheet_close_rounded'"></cs-icon>
  </div>

  <div class="tw-flex tw-flex-col tw-items-center tw-gap-4">
    <img src="/assets/gifs/exclamation.gif"
         alt=""
         class="tw-h-12 tw-w-12 tw-object-contain" />
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-text-center">
      <p class="tw-font-lexend tw-text-500 tw-font-bold tw-text-gray-800"
         i18n="@@deletePhotoSheetHeader"
         id="deletePhotoWarning">
        Your doctor needs this photo for your treatment. We strongly recommend keeping it.
      </p>
      <p class="tw-font-body tw-text-300 tw-font-medium tw-text-gray-500"
         i18n="@@deletePhotoSheetSubtext"
         id="deletePhotoSubtext">
        Your doctor will use it to assess your skin accurately and track your progress. If there's an issue, take a new one instead of deleting it.
      </p>
    </div>
  </div>

  <div class="tw-flex tw-w-full tw-flex-col tw-gap-2">
    @if (!data.hideNewPhotoOption) {
      <button csButton
              class="tw-w-full"
              (click)="takeNewPhoto()"
              id="takeNewPhotoBtn">
        <span i18n="@@takeNewPhoto">Take New Photo</span><span>&nbsp;></span>
      </button>
    }
    <button [csButton]="data.hideNewPhotoOption ? '' : 'muted'"
            class="tw-w-full"
            (click)="deleteCurrentPhoto()"
            id="deleteCurrentPhotoBtn">
      <span i18n="@@DELETE_PHOTO">Delete Photo</span>
    </button>
  </div>
</div>
